import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ScreenIdMstSelectorButton from '@/components/Ui/ScreenIdMstSelectorButton'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'NoticeTypeMst',
  components: {
    Loading,
    ScreenIdMstSelectorButton
  },
  metaInfo () {
    let title = this.categoryName + 'マスタ | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'noticeTypeMstId',
        'noticeTypeName',
        'noticeType',
        'screenId',
        'noticeTypeStatus',
        'modifyButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          noticeTypeMstId: 'お知らせタイプID',
          noticeTypeName: 'お知らせタイプ名',
          noticeType: 'お知らせタイプ',
          screenId: '画面コード',
          noticeTypeStatus: 'ステータス',
          modifyButton: ''
        },
        columnsClasses: {
          noticeTypeMstId: 'wp-5',
          noticeTypeName: '',
          noticeType: '',
          screenId: '',
          noticeTypeStatus: '',
          modifyButton: 'wp-5 has-button'
        },
        sortable: [
          'noticeTypeMstId',
          'noticeTypeName',
          'noticeType',
          'screenId',
          'noticeTypeStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.noticeTypeMst.categoryName,

      // model
      noticeTypeMstModel: state => state.noticeTypeMst.noticeTypeMstModel,

      // form
      values: state => state.noticeTypeMst.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'noticeTypeMst/isRegister',
      isModify: 'noticeTypeMst/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.noticeTypeMstModel, 'noticeTypeMstUuid', this.modifyTargetId, 'noticeTypeMstId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpNoticeTypeName: {
      get () {
        return this.values.inpNoticeTypeName
      },
      set (value) {
        this.setInputValue({
          key: 'inpNoticeTypeName',
          value: value
        })
      }
    },
    inpNoticeType: {
      get () {
        return this.values.inpNoticeType
      },
      set (value) {
        this.setInputValue({
          key: 'inpNoticeType',
          value: value
        })
      }
    },
    inpScreenIdMstId: {
      get () {
        return this.values.inpScreenIdMstId
      },
      set (value) {
        this.setInputValue({
          key: 'inpScreenIdMstId',
          value: value
        })
      }
    },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // validate
    inpNoticeTypeNameIsValid () {
      return Validator.validText(this.inpNoticeTypeName)
    },
    inpNoticeTypeIsValid () {
      return Validator.validText(this.inpNoticeType)
    },
    inpScreenIdMstIdIsValid () {
      return Validator.validText(this.inpScreenIdMstId)
    },
    inpStatusIsValid () {
      return Validator.validSelect(this.inpStatus)
    },
    formIsValid () {
      return this.inpNoticeTypeNameIsValid &&
        this.inpNoticeTypeIsValid &&
        // this.inpScreenIdMstIdIsValid &&
        this.inpStatusIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'noticeTypeMst/loadModel',
      initRegister: 'noticeTypeMst/initRegister',
      initModify: 'noticeTypeMst/initModify',
    }),
    ...mapMutations({
      setInputValue: 'noticeTypeMst/setInputValue',
    }),

    init () {
      this.loading = true

      //TODO
      let noticeTypeMstParams = {}

      // データ読出し
      this.loadModel({
        noticeTypeMstParams: noticeTypeMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.noticeTypeMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    /**
     * 固定画面の変更
     */
    changeScreenIdValue (props) {
      this.inpScreenIdMstId = props.data
    },
    deleteScreenIdValue (props) {
      this.inpScreenIdMstId = null
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.noticeTypeMstModel, 'noticeTypeMstUuid', this.modifyTargetId, 'noticeTypeMstId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true
      // console.log(this.isModify)
      let parameters = {
        request: {
          noticeTypeName: this.inpNoticeTypeName,
          noticeType: this.inpNoticeType,
          screenIdMstUuid: this.inpScreenIdMstId,
          noticeTypeStatus: this.inpStatus
        }
      }
      if (this.isModify) {
        parameters.noticeTypeMstUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['noticeTypeMst'],
        [this.isRegister ?
          'v1NoticeTypeMstPost' :
          'v1NoticeTypeMstPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'noticeTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
        case 'screenId':
          return value === null ? Constants.BlankValue : value
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.modifyTargetId = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.noticeTypeMstUuid
      this.initModify({
        data: props.row
      })
    },
  }
}